import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { EfileRoutingModule } from './efile-routing.module';
import { SubmissionDataComponent } from './submission-data/submission-data.component';
import { SubmissionDetailComponent } from './submission-data/submission-detail/submission-detail.component';
import { UploadIRSComponent } from './upload-irs-schema/upload-irs.component';

import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
// MatTabsModule was used to render the Submission List + open submission
// tabs via `<mat-tab-group>`. The submission shell now uses a custom
// DST-style `.app-nav` strip (see submission-data.component.html), so
// MatTabsModule is no longer needed here.
import { MatIconModule } from '@angular/material/icon';
import { CellHighlightDirective } from './directives/cell-highlighter';
import { SubmitComponent } from './submission-data/submit/submit.component';
import { DashboardComponent } from './submission-data/dashboard/dashboard.component';
import { ReviewDiagnostics } from './submit-confirmation/review-diagnostics.component';
import { AdminModule } from '../admin/admin.module';
import { EfileReviewAttachmentUpload } from './review-attachment-upload/review-attachment-upload.component';
import { Process5713LinesComponent } from './process-5713-lines/process-5713-lines.component';
import { EfileEditKeyTableDataComponent } from './edit-key-table-data/efile-edit-key-table-data.component';
import { EfileSubmissionManifestTableComponent } from './efile-submission-manifest-table/efile-submission-manifest-table.component';
import { EfileEditSubmissionTableDataComponent } from './edit-submission-table-data/efile-edit-submission-table-data.component';
import { AdminservicesModule } from './adminservices/adminservices.module';
import { CoreModule } from '../core/core.module';
import { BatchSubmissionComponent } from './components/batch-submission/batch-submission.component';
import { ScrubbingConfirmationComponent } from './components/scrubbing-confirmation/scrubbing-confirmation.component';
import { OverrideModalComponent } from './components/override-modal/override-modal.component';
import { CommentsModalComponent } from './components/comments-modal/comments-modal.component';
import { CreateNewScrubbingComponent } from './components/create-new-scrubbing/create-new-scrubbing.component';
import { DashboardPopupComponent } from './components/dashboard-popup/dashboard-popup.component';
import { ReqHeaderElementsComponent } from './components/req-header-elements/req-header-elements.component';
import { IgnoreModalComponent } from './components/ignore-modal/ignore-modal.component';
import { PingIrsComponent } from './components/ping-irs/ping-irs.component';
import { UploadFilesComponent } from './components/upload-files/upload-files.component';
import { DeleteFormComponent } from './components/delete-form/delete-form.component';
import { LockUnlockComponent } from './components/lock-unlock/lock-unlock.component';
import { EfileAddEditComponent } from './components/add-edit/add-edit.component';
import { EfileTypeaheadSelectComponent } from './components/efile-typeahead-select/efile-typeahead-select.component';
import { EfileElementsDashboardComponent } from './components/efile-elements-dashboard/efile-elements-dashboard.component';
import { EfileElementsDataComponent } from './components/efile-elements-data/efile-elements-data.component';
import { EfileElementsGridTplComponent } from './components/efile-elements-grid-tpl/efile-elements-grid-tpl.component';
import { EfileElementsListTplComponent } from './components/efile-elements-list-tpl/efile-elements-list-tpl.component';
import { AmendSupersededReturnsComponent } from './components/amend-superseded-returns/amend-superseded-returns.component';
import { XmlConsolUploadComponent } from './components/xml-consol-upload/xml-consol-upload.component';
import { XmlSyncComponent } from './components/xml-sync/xml-sync.component';
import { SubmitActionComponent } from './components/submit-action/submit-action.component';
import { MigrationHistoryComponent } from './components/migration-history/migration-history.component';
import { EfileAdminShellComponent } from './components/efile-admin-shell/efile-admin-shell.component';
import { ConfirmationModalModule } from '../shared/components/confirmation-modal/confirmation-modal.module';
import { EfileReturnReviewComponent } from './components/return-review/efile-return-review.component';
import { EfileReturnReviewDashboardComponent } from './components/return-review/efile-return-review-dashboard.component';
import { EfileValidationErrorsComponent } from './components/return-review/efile-validation-errors/efile-validation-errors.component';
import { EfileScrubbingComponent } from './components/efile-scrubbing/efile-scrubbing.component';
import { EfileSetupComponent } from './components/efile-setup/efile-setup.component';
import { PdfUploadComponent } from './components/pdf-upload/pdf-upload.component';
import { EfileKeyXmlGenComponent } from './components/key-xml-gen/efile-key-xml-gen.component';
import { EfileOverridesComponent } from './components/overrides/efile-overrides.component';
import { EfileXmlCompareComponent } from './components/xml-compare/efile-xml-compare.component';
import { EfileGridDirective } from './shared/efile-grid.directive';
import { ExDashboardModule } from '../core/executive-dashboards/ex-dashboard.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { GtwSearchableSelectModule } from '../shared/_directives/gtw-searchable-select/gtw-searchable-select.module';

const components = [
  SubmissionDataComponent,
  UploadIRSComponent,
  SubmissionDetailComponent,
  ReviewDiagnostics,
  EfileReviewAttachmentUpload,
  Process5713LinesComponent,
  EfileEditKeyTableDataComponent,
  EfileSubmissionManifestTableComponent,
  EfileEditSubmissionTableDataComponent,
  BatchSubmissionComponent,
  ScrubbingConfirmationComponent,
  OverrideModalComponent,
  CommentsModalComponent,
  CreateNewScrubbingComponent,
  DashboardPopupComponent,
  ReqHeaderElementsComponent,
  IgnoreModalComponent,
  PingIrsComponent,
  UploadFilesComponent,
  DeleteFormComponent,
  LockUnlockComponent,
  EfileAddEditComponent,
  EfileTypeaheadSelectComponent,
  EfileElementsDashboardComponent,
  EfileElementsDataComponent,
  EfileElementsGridTplComponent,
  EfileElementsListTplComponent,
  AmendSupersededReturnsComponent,
  XmlConsolUploadComponent,
  XmlSyncComponent,
  SubmitActionComponent,
  MigrationHistoryComponent,
  EfileAdminShellComponent,
  EfileReturnReviewComponent,
  EfileReturnReviewDashboardComponent,
  EfileValidationErrorsComponent,
  EfileScrubbingComponent,
  EfileSetupComponent,
  PdfUploadComponent,
  EfileKeyXmlGenComponent,
  EfileOverridesComponent,
  EfileXmlCompareComponent,
]

@NgModule({
  declarations: [
    ...components,
    CellHighlightDirective,
    EfileGridDirective,
    SubmitComponent,
    DashboardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    EfileRoutingModule,
    AppNgAppkitModule,
    AppNgMaterialModule,
    CdkScrollableModule,
    MatIconModule,
    AdminModule,
    AdminservicesModule,
    CoreModule,
    ConfirmationModalModule,
    ExDashboardModule,
    SharedDirectivesModule,
    GtwSearchableSelectModule,
  ],
  exports: [...components, EfileGridDirective],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
  schemas: [NO_ERRORS_SCHEMA]

})
export class EfileModule { }
